<script>
	import { Tabs, TabList, TabPanel, Tab } from '../components/tabs/tabs.js';
	import { slide } from "svelte/transition";
	let visible = true;
	let generalfaqs = [
		{
			id: 1,
			title: "What is BATTLEGROUNDS MOBILE INDIA?",
			content:
				'BATTLEGROUNDS MOBILE INDIA is an online multiplayer battle royale game developed and published by KRAFTON, INC. for mobile phones. ',
			active: false,
		},
		{
			id: 2,
			title: "HOW TO PLAY BATTLEGROUNDS MOBILE INDIA? ",
			content:
				"<ul><li>Download the BATTLEGROUNDS MOBILE INDIA app from the play store for Android devices and apple store for iOS devices. </li><li>Play Store link: <a href ='https://play.google.com/store/apps/details?id=com.pubg.imobile' target='block'> https://play.google.com/store/apps/details?id=com.pubg.imobile </a></li><li>Apple Store link: <a href='https://apps.apple.com/in/app/battlegrounds-mobile-india/id1526436837' target='blank'> https://apps.apple.com/in/app/battlegrounds-mobile-india/id1526436837 </a> </li><li>Create an account within the app. </li><li>Play and enjoy </li></ul>",
			active: false,
		},
		{
			id: 3,
			title: "Who is organizing the SNAPDRAGON CONQUEST MOBILE OPEN?",
			content:
				"SNAPDRAGON CONQUEST MOBILE OPEN is organized by Qualcomm and its official tournament partner – Tesseract Esports.",
			active: false,
		},
		{
			id: 4,
			title: "What are the tournament rules?",
			content:
				"You can find the complete rulebook at <a href='http://www.snapdragonconquest.com/rulebook.pdf' target='_block'>rulebook</a>",
			active: false,
		},
		{
			id: 5,
			title: "How will we be playing- mobile or PC? ",
			content:
				"This is a mobile- only online tournament and usage of emulators in the tournament is strictly prohibited.",
			active: false,
		},
		{
			id: 6,
			title: "Can I use triggers or Emulators?",
			content:
				"No, triggers and emulators or any other add-on devices are strictly prohibited. Team/Players will be disqualified if found to be using additional devices.",
			active: false,
		},
		{
			id: 7,
			title: "What is the Prize Pool?",
			content:
				"The prize pool is worth INR 50 lakhs worth cash. The awards are based on team positions. Special awards would also be given to individual players to highlight their excellence in different categories.",
			active: false,
		},
		{
			id: 8,
			title: "How is the prize pool distributed?",
			content:
				"<p>Below is a detailed breakdown of the prizes at stake.</p><table class='table table-bordered table-sm'><thead><tr><td>Rank </td><td>Prize Money (INR) </td></tr></thead><tbody><tr><td>1st  </td><td>15,00,000  </td></tr><tr><td>2nd   </td><td>7,50,000  </td></tr><tr><td>3rd  </td><td>4,50,000  </td></tr><tr><td>4th  </td><td>3,00,000  </td></tr><tr><td>5th  </td><td>2,00,000  </td></tr><tr><td>6th  </td><td>1,50,000  </td></tr><tr><td>7th  </td><td>1,00,000  </td></tr><tr><td>8th  </td><td>80,000  </td></tr><tr><td>9th - 10th  </td><td>75,000  </td></tr><tr><td>11th - 12th </td><td>40,000  </td></tr><tr><td>13th - 16th </td><td>25,000  </td></tr><tr><td>17th - 20th</td><td>20,000  </td></tr><tr><td>21st - 24th </td><td>15,000  </td></tr></tbody></table><table class='table table-bordered table-sm'><thead><tr><td>Category </td><td>Prize Money (INR)   </td><td>Award Information  </td></tr></thead><tbody>   <tr>   <td>Most Valuable Player  </td>   <td>50,000 </td>   <td>Player with the most finishes  </td>   </tr>   <tr><td>Most Finishes by a Squad    </td><td>50,000 </td><td>Team with the most finishes   </td></tr><tr><td>WWCD </td><td>3,00,000  </td><td>Winner of each match in the Grand Finals series (10,000 INR*30 Winners)</td></tr></tbody></table>",
			active: false,
		},
		{
			id: 9,
			title: "How do I get the money if I win? ",
			content:
				"The prize money will be directly transferred to the winners’ bank accounts. The details will be collected, and the deposit will be made within 90 days (about 3 months).",
			active: false,
		},
		{
			id: 10,
			title: "Is the prize money subject to Government taxes or deductions? ",
			content:
				"Yes. Like winnings from any other tournament, the tax amount will be deducted at source (TDS) in accordance with the Government regulations. ",
			active: false,
		},
		{
			id: 11,
			title: "What are the phases of the tournament?",
			content:
				"Tournament Phases <ol list-style-type:'1'><li>Registrations</li> <li>Open Qualifiers</li><li>Challenger Round</li><li>Contender Round</li><li>League Stage</li><li>Quarter Finals</li><li>Semi Finals</li><li>Grands Finals</li></ol>",
			active: false,
		},
		{
			id: 12,
			title: "What is the format of the tournament?",
			content:
				"You can find all information on the tournament format here <a href='https://snapdragonconquest.com/format'>https://snapdragonconquest.com/format</a> ",
			active: false,
		},
		{
			id: 13,
			title: "Where should I play in the tournament?",
			content:
				"You can play the tournament from anywhere you wish to as long as you can maintain an internet connection since the tournament matches are going to be played online. However, you need to be physically present at the venue if the tournament organizer decides to hold the finals at a venue",
			active: false,
		}
		
	];

	const expand = (generalfaqcontent) => {
		generalfaqs = generalfaqs.map((s) => {
			let c = generalfaqs.find(i =>i.active);
			s.active = false;
			if(!c || c && c.id != generalfaqcontent.id)
			if (s.id === generalfaqcontent.id) {
				s.active = true;
			}
			return s;
		});
	};

	// for Registration
	let registrationfaqs = [
		{
			id: 1,
			title: "How to register for the tournament?",
			content:
				'<p>·	Visit the official website - <a href="http://www.snapdragonconquest.com/">http://www.snapdragonconquest.com/</a> </p><ul><li>Click on the “Register Now” button on the homepage. </li><li>Enter your "Email ID" and verify with the OTP received on your Email. </li><li>Fill in your details </li><li>Accept the terms and conditions </li></ul> <p>You are now registered on the website. To complete registrations for the tournament either create a team or join a team. Only a complete team of 4 players will be considered eligible to participate in the tournament.</p>',
			active: false,
		},
		{
			id: 2,
			title: "WHAT DO I REQUIRE FOR REGISTERING? ",
			content:
				'<p>You need your mail ID, phone number, BGMI Character ID, and Govt. ID proof to register for the SNAPDRAGON CONQUEST MOBILE OPEN.</p>',
			active: false,
		},
		{
			id: 3,
			title: "WHAT IS THE CHARACTER ID? WHERE CAN I FIND MY CHARACTER ID? ",
			content:
				'<p>BGMI Character ID is the unique numerical ID that is assigned to your BGMI account. To find your character ID</p><ul><li>Open BATTLEGROUNDS MOBILE INDIA on your device. </li><li>·	Tap on your profile icon on the top left corner of the home screen</li><li>·	Above your display profile picture, you will find unique character ID mentioned as “ID: XXXXXXX”.</li><li>·	Copy character ID number by tapping on the copy button on the side of the number</li></ul>',
			active: false,
		},
		{
			id: 4,
			title: "Are there any criteria for participating in the tournament?",
			content:
				'<p>Some of the important criteria include</p> <ul><li>You must be 16 years or older to be eligible to participate in the tournament.</li><li>You must be an Indian Citizen.</li><li>To complete registration, you must have 4 members in your team before the registration closes.</li></ul><p>Please read the rulebook for more detailed information - <a href="http://www.snapdragonconquest.com/rulebook.pdf" target="_block">rulebook</a></p> ',
			active: false,
		},
		{
			id: 5,
			title: "Is there a registration cost or fee for participating in the tournament? ",
			content:
				'No, SNAPDRAGON CONQUEST MOBILE OPEN is free to participate the tournament. There is no registration fee or cost involved.',
			active: false,
		},
		{
			id: 6,
			title: "Are the registrations limited?",
			content:
				'The registrations are not limited- the more the merrier!',
			active: false,
		},
		
		{
			id: 8,
			title: "Can I add or modify team members during registrations?",
			content:
				'Yes, if you are the team leader you can add or modify team members till registrations close. Please note that you cannot make changes to your team once the registrations close.',
			active: false,
		},
		{
			id: 9,
			title: "How do I create my team? ",
			content:
				'<ul><li>Go to the user dashboard.</li><li>On the Your Team panel, enter the team name, and click on Create Team</li><li>Invite 3 more of your friends to join the team</li></ul>',
			active: false,
		},
		{
			id: 10,
			title: "HOW DO I INVITE PLAYERS TO JOIN MY TEAM? ",
			content:
				'<p>Once you have created your team, </p><ul><li>Go to “Your Team” section of the dashboard. </li><li>Click on “ + add player”. </li><li>Copy the invite code and share it with your friends or enter your friend’s email id to send them an invite link. </li></ul>',
			active: false,
		},
		{
			id: 11,
			title: "IS IT MANDATORY TO ADD AN OWNER/MANAGER TO THE TEAM?",
			content:
				'No, it’s not. By default, the captain of the team is also considered as the owner/manager of the team. In case your team has an owner/manager we highly recommend you to add them.',
			active: false,
		},
		{
			id: 12,
			title: "HOW DO I ADD MY OWNER/MANAGER TO MY TEAM? ",
			content:
				'<p>Once you have created your team, </p><ul><li>Go to “Your Team” section of the dashboard. </li><li>Go to the complete your team panel. </li><li>Click on “ + add Owner/Manager”. </li><li>Enter your owner’s/manager’s email id to send them an invite link. </li><li>The owner/manager will have the same rights over the team as the captain.</li></ul>',
			active: false,
		},
		{
			id: 13,
			title: "HOW DO I REMOVE A PLAYER FROM MY TEAM? ",
			content:
				'<ul><li>Go to “Your Team” section of the dashboard. </li><li>Click on the drop-down option on the top right of the player you wish to remove. </li><li>Click on “remove player”. </li></ul><p>You can invite the player back again by sharing the invite code or link. </p>',
			active: false,
		},
		{
			id: 14,
			title: "HOW DO I REMOVE OWNER/MANAGER FROM MY TEAM? ",
			content:
				'<ul><li>Go to “Your Team” section of the dashboard. </li><li>Click on the drop-down option on the top right of the owner/manager.</li><li>Click on “remove Owner/Manager”. </li></ul><p>You can invite the owner/manager back again by sending them an invite</p>',
			active: false,
		},
		{
			id: 15,
			title: "HOW DO I MAKE ANOTHER PLAYER IN MY TEAM THE TEAM LEADER? ",
			content:
				'<p>Once you have created your team, </p><ul><li>Go to “Your Team” section of the dashboard . </li><li>Click on the drop-down option on the top right of the player you wish to make leader. </li><li>Click “Make Leader”. </li></ul><p>As a team leader you can only leave the team once you make another team member the leader. </p>',
			active: false,
		},
		{
			id: 16,
			title: "HOW DO I DELETE OR DISBAND A TEAM?",
			content:
				'<p>If you are the team leader</p> <ul><li>Go to “Your Team” section of the dashboard .</li><li>Click on the drop-down option on the top of the team panel.</li><li>Click “Delete Team”. </li></ul><p><b>Warning: </b> You can only delete the team after you kick all the players. </p>',
			active: false,
		},
		{
			id: 17,
			title: "HOW DO I JOIN A TEAM? ",
			content:
				'<p>After registering your account </p><ul><li>Go to “Your Team” section of the dashboard .</li><li>Click the “Join a team” in the Join a team panel. </li><li>Paste the invite code shared by your friends or click on find a team to join. </li><li>Input either the Team Leader or Team Name in the search bar to find the team to join. </li></ul>',
			active: false,
		},
		{
			id: 18,
			title: "HOW DO I LEAVE A TEAM? ",
			content:
				'<p>If you are the team leader, to leave the team you would have to assign another member of your team as the leader first. Once done you can leave the team by clicking the drop-down menu on the top right of the team panel and leaving team.</p><p>If you are not the team leader, you can leave the team you joined at any time by pressing the leave team below the team panel. </p>',
			active: false,
		},
		{
			id: 19,
			title: "I TRIED JOINING/LEAVING A TEAM OR REMOVING A TEAM MEMBER BUT MY STATUS ISN'T UPDATING?",
			content:
				'Please refresh your browser once and you will see the updated status. ',
			active: false,
		},
		{
			id: 20,
			title: "Can I register with one member in my team? ",
			content:
				'Unfortunately, the format does not allow for solo players to register. This is to prevent matches from becoming one- sided since teams without a full squad are bound to start with a disadvantage. However, we suggest you get your buddies to register along with you and join us on this wild ride that promises a thrilling time for everyone involved!',
			active: false,
		},
		{
			id: 21,
			title: "Can I register with two members in my team? ",
			content:
				'Unfortunately, the format does not allow for players without 4 members in their squad to register. This is to prevent matches from becoming one- sided since teams without a full squad are bound to start with a disadvantage. However, we suggest you get your buddies to register along with you and join us on this wild ride that promises a thrilling time for everyone involved!',
			active: false,
		},
		{
			id: 22,
			title: "Can I register with three members in my team? ",
			content:
				'Unfortunately, the format does not allow for players without 4 members in their squad to register. This is to prevent matches from becoming one- sided since teams without a full squad are bound to start with a disadvantage. However, we suggest you get your buddies to register along with you and join us on this wild ride that promises a thrilling time for everyone involved!',
			active: false,
		},
		{
			id: 23,
			title: "What happens if I don’t complete my team during registrations? ",
			content:
				'Only a complete team i.e., a 4-member team will be eligible to participate in the tournament. If you don’t complete your team or are part of an incomplete team before the end of registrations, you will not be eligible to participate in the tournament.',
			active: false,
		},
	];

	const registrationfaqsopen = (registrationcontent) => {
		registrationfaqs = registrationfaqs.map((s) => {
			let c = registrationfaqs.find(i =>i.active);
			s.active = false;
			if(!c || c && c.id != registrationcontent.id)
			if (s.id === registrationcontent.id) {
				s.active = true;
			}
			return s;
		});
	};

	// for Tournament
		// for Registration
	let tournamentfaqs = [
		{
			id: 1,
			title: "When does the Open Qualifiers begin?",
			content:
				'The Open qualifiers will begin once the registrations close and seeding completes. Check out the schedule at <a href="https://snapdragonconquest.com/schedule">https://snapdragonconquest.com/schedule</a> and follow us on Facebook, Instagram, and Twitter to stay up to date on all the latest info.',
			active: false,
		},
		{
			id: 2,
			title: "How many teams will participate in the Open qualifiers?",
			content:
				'All registered teams with all 4 team members will be eligible to participate in the Open qualifiers.',
			active: false,
		},
		{
			id: 3,
			title: "Can my team use substitutes who are not registered once the Open qualifiers begin?",
			content:
				'No, you cannot use unregistered players once the tournament begins.',
			active: false,
		},
		{
			id: 4,
			title: " How to play the Open qualifiers?",
			content:
				'Once registered the team will be required to play in a series of two (2) matches. The total scores of the squad in two (2) matches will be considered for qualification to the next round.',
			active: false,
		},
		{
			id: 5,
			title: "When does the Challenger Round begin? ",
			content:
				'The Challenger Round will begin once the Open Qualifier end. Check out the schedule at <a href="https://snapdragonconquest.com/schedule"> https://snapdragonconquest.com/schedule</a> and follow us on Facebook, Instagram, and Twitter to stay up to date on all the latest info.',
			active: false,
		},
		{
			id: 6,
			title: "How many teams will participate in the Challenger Round?",
			content:
				'The qualified 112 Teams from Open Qualifiers and 16 Invited Teams will be playing Challenger Round. ',
			active: false,
		},
		{
			id: 7,
			title: "What is the format for the online playoffs?",
			content:
				'You can find all information on the tournament format here <a href="https://snapdragonconquest.com/schedule"> https://snapdragonconquest.com/schedule</a>',
			active: false,
		},
		{
			id: 8,
			title: "Where to find lobby ID and password?",
			content:
				' <b>For Open Qualifiers, Challenger Round, Contender Round, League Stage, Quarter Finals, Semi Finals, Grand Finals</b>: Lobby ID and password will be shared with you via the user dashboard and on community platforms like WhatsApp or Discord before the match by tournament organizers. You will receive an invite link to the community.',
			active: false,
		},
		{
			id: 9,
			title: "When does the Contender Round begin?",
			content:
				'The Contender Round will begin once the Challenger Round end. Check out the schedule at <a href="https://snapdragonconquest.com/schedule"> https://snapdragonconquest.com/schedule</a> and follow us on Facebook, Instagram, and Twitter to stay up to date on all the latest info.',
			active: false,
		},
		{
			id: 10,
			title: "How many teams will participate in the Contender Round?",
			content:
				'The qualified 56 Teams and additional 8 Invited Teams will be playing Contender Round.',
			active: false,
		},
		{
			id: 11,
			title: "What is the format for the Contender Round?",
			content:
				'You can find all information on the tournament format here <a href="https://snapdragonconquest.com/format"> https://snapdragonconquest.com/format</a>',
			active: false,
		},
		{
			id: 12,
			title: "When does the League Stage begin?",
			content:
				'The League Stage will begin once the Contender Round end. Check out the schedule at <a href="https://snapdragonconquest.com/schedule"> https://snapdragonconquest.com/schedule</a> and follow us on Facebook, Instagram, and Twitter to stay up to date on all the latest info.',
			active: false,
		},
		{
			id: 13,
			title: "How many teams will participate in the League Stage?",
			content:
				'The qualified 24 Teams and additional 8 Invited Teams will be playing League Stage.',
			active: false,
		},
		{
			id: 14,
			title: "What is the format for the League Stage?",
			content:
				'You can find all information on the tournament format here <a href="https://snapdragonconquest.com/format"> https://snapdragonconquest.com/format</a>',
			active: false,
		},{
			id: 15,
			title: "When does the Quarter Finals begin?",
			content:
				'The Quarter Finals will begin once the League Stage end. Check out the schedule at <a href="https://snapdragonconquest.com/schedule"> https://snapdragonconquest.com/schedule</a> and follow us on Facebook, Instagram, and Twitter to stay up to date on all the latest info.',
			active: false,
		},
		{
			id: 16,
			title: "How many teams will participate in the Quarter Finals?",
			content:
				'The qualified 24 Teams will be playing in Quarter Finals.',
			active: false,
		},
		{
			id: 17,
			title: "What is the format for Quarter Finals?",
			content:
				'You can find all information on the tournament format here<a href="https://snapdragonconquest.com/format"> https://snapdragonconquest.com/format</a>',
			active: false,
		},
		{
			id: 18,
			title: "When does the Semi Finals begin?",
			content:
				'The Semi Finals will begin once the Quarter Finals end. Check out the schedule at <a href="https://snapdragonconquest.com/schedule"> https://snapdragonconquest.com/schedule</a>and follow us on Facebook, Instagram, and Twitter to stay up to date on all the latest info.',
			active: false,
		},
		{
			id: 19,
			title: "How many teams will participate in the Semi Finals?",
			content:
				'The qualified 20 Teams will be playing in Semi Finals.',
			active: false,
		},
		{
			id: 20,
			title: "What is the format for Semi Finals?",
			content:
				'You can find all information on the tournament format here <a href="https://snapdragonconquest.com/format"> https://snapdragonconquest.com/format</a>',
			active: false,
		},
		{
			id: 21,
			title: "When does the Grand Finals begin?",
			content:
				'The Grand Finals will begin once the Semi Finals end. Check out the schedule at  <a href="https://snapdragonconquest.com/schedule"> https://snapdragonconquest.com/schedule</a> and follow us on Facebook, Instagram, and Twitter to stay up to date on all the latest info.',
			active: false,
		},
		{
			id: 22,
			title: "How many teams will participate in the Grand Finals?",
			content:
				'The qualified 16 Teams will be playing in Grand Finals.',
			active: false,
		},
		{
			id: 23,
			title: "What is the format for Grand Finals?",
			content:
				'You can find all information on the tournament format here <a href="https://snapdragonconquest.com/format"> https://snapdragonconquest.com/format</a>',
			active: false,
		},
	];

	const tournamentfaqsopen = (tournamentcontent) => {
		tournamentfaqs = tournamentfaqs.map((s) => {
			let c = tournamentfaqs.find(i =>i.active);
			s.active = false;
			if(!c || c && c.id != tournamentcontent.id)
			if (s.id === tournamentcontent.id) {
				s.active = true;
			}
			return s;
		});
	};

	// for Tournament
		// for Registration
	// let onlineQualifiersfaq = [
	// 	{
	// 		id: 1,
	// 		title: "WHAT ARE ONLINE QUALIFIERS - ROUND 1?",
	// 		content:
	// 			'512 squads that qualify during the In-game Qualifiers will be battling each other in a Round 1 over the course of 4 days. From this pool, the top 256 teams will secure their place in the Round 2.  ',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 2,
	// 		title: "WHERE DO I PLAY ONLINE QUALIFIERS - ROUND 1 FROM?  ",
	// 		content:
	// 			'Anywhere from your personal mobile with your registered squad. ',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 3,
	// 		title: "HOW DO I PLAY ONLINE QUALIFIERS - ROUND 1? ",
	// 		content:
	// 			'In the time period of 21 April 2022 to 24 April 2022, the qualified 512 squads will be allotted with custom room matches. ',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 4,
	// 		title: "WHAT IS THE FORMAT OF ONLINE QUALIFIERS - ROUND 1?",
	// 		content:
	// 			'Refer to <a href="https://esports.battlegroundsmobileindia.com/" targer="_blank">esports.battlegroundsmobileindia.com</a> for Online Qualifiers Round 1 format.',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 5,
	// 		title: "WHAT ARE ONLINE QUALIFIERS - ROUND 2? ",
	// 		content:
	// 			'256 squads that qualify during the Online Qualifiers Round -1 will be battling each other in a Round 2 over the course of 4 days. From this pool, the top 64 teams will secure their place in the Round 3. ',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 6,
	// 		title: "WHERE DO I PLAY ONLINE QUALIFIERS - ROUND 2 FROM?  ",
	// 		content:
	// 			'Anywhere from your personal mobile with your registered squad.',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 7,
	// 		title: "HOW DO I PLAY ONLINE QUALIFIERS - ROUND 2? ",
	// 		content:
	// 			'In the time period of 27 April 2022 to 30 April 2022, the qualified 256 squads will be allotted with custom room matches.   ',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 8,
	// 		title: "WHAT IS THE FORMAT OF ONLINE QUALIFIERS - ROUND 2? ",
	// 		content:
	// 			'Refer to <a href="https://esports.battlegroundsmobileindia.com/" target="_blank">esports.battlegroundsmobileindia.com </a> for Online Qualifiers Round 2 format. ',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 9,
	// 		title: "WHAT ARE ONLINE QUALIFIERS - ROUND 3? ",
	// 		content:
	// 			'64 squads that qualify during the Online Qualifiers Round -2 will be battling each other in a Round 3 over the course of 4 days. From this pool, the top 32 teams will secure their place in the Round 4. ',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 10,
	// 		title: "WHERE DO I PLAY ONLINE QUALIFIERS - ROUND 3 FROM?  ",
	// 		content:
	// 			'Anywhere from your personal mobile with your registered squad. ',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 11,
	// 		title: "HOW DO I PLAY ONLINE QUALIFIERS - ROUND 3? ",
	// 		content:
	// 			'In the time period of 5 May 2022 to 8 May 2022, the qualified 64 squads will be allotted with custom room matches.  ',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 12,
	// 		title: "WHAT IS THE FORMAT OF ONLINE QUALIFIERS - ROUND 3?",
	// 		content:
	// 			'Refer to <a href="https://esports.battlegroundsmobileindia.com/" target="_blank">esports.battlegroundsmobileindia.com </a> for Online Qualifiers Round 3 format.',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 13,
	// 		title: " WHAT ARE ONLINE QUALIFIERS - ROUND 4?",
	// 		content:
	// 			'32 squads that qualify during the Online Qualifiers Round -3 along with 32 invited teams will be battling each other in a Round 4 over the course of 4 days. From this pool, the top 24 teams will secure their place in the BATTLEGROUNDS MOBILE INDIA PRO SERIES 2022.',
	// 		active: false,
	// 	},
	// 	{
	// 		id: 14,
	// 		title: "WHERE DO I PLAY ONLINE QUALIFIERS - ROUND 4 FROM? ",
	// 		content:
	// 			'Anywhere from your personal mobile with your registered squad.  ',
	// 		active: false,
	// 	},
		
	// 	{
	// 		id: 15,
	// 		title: "HOW DO I PLAY ONLINE QUALIFIERS - ROUND 4? ",
	// 		content:
	// 			'In the time period of 12 May 2022 to 15 May 2022, the qualified 64 squads will be allotted with custom room matches.   ',
	// 		active: false,
	// 	}
	// 	,
	// 	{
	// 		id: 16,
	// 		title: "WHAT IS THE FORMAT OF ONLINE QUALIFIERS - ROUND 4? ",
	// 		content:
	// 			' Refer to <a href="https://esports.battlegroundsmobileindia.com/" target="_blank">esports.battlegroundsmobileindia.com </a> for Online Qualifiers Round 4 format',
	// 		active: false,
	// 	}
	// ];

	// const onlineQfaqsopen = (onlineQcontent) => {
	// 	onlineQualifiersfaq = onlineQualifiersfaq.map((s) => {
	// 		let c = onlineQualifiersfaq.find(i =>i.active);
	// 		s.active = false;
	// 		if(!c || c && c.id != onlineQcontent.id)
	// 		if (s.id === onlineQcontent.id) {
	// 			s.active = true;
	// 		}
	// 		return s;
	// 	});
	// };
</script>
<svelte:head>
	<link
		href="https://fonts.googleapis.com/icon?family=Material+Icons"
		rel="stylesheet" />
</svelte:head>
<div class="banner-section faq-banner">
	<h1 class="main-heading">Frequently asked questions</h1>
	<p>
		Having issues? Contact us at <a href="mailto:support@snapdragonconquest.com">support@snapdragonconquest.com</a>
	</p>
</div>
<Tabs>
	<TabList>
		<Tab>General</Tab>
		<Tab>Registrations</Tab>
		<Tab>Tournament</Tab>
		<!-- <Tab>ONLINE - QUALIFIERS</Tab> -->
	</TabList>
	<TabPanel>
		<div class="faq-section container">
			{#each generalfaqs as generalfaqcontent}
				<div class="accordion">
					<div class="row no-gutters">
						<div class="col-lg-12 col-sm-12 col-xs-12">
							<div class="accordion-list" on:click={() => expand(generalfaqcontent)}>
								<div class="question-title">{generalfaqcontent.title}</div>
								<div class="material-icons plus-icon">{generalfaqcontent.active ? 'remove_circle_outline' : 'add_circle_outline'}</div>
							</div>
						</div>
					</div>
					{#if generalfaqcontent.active}
						<div class="slider row no-gutters" transition:slide>
							<div class="col-12">
								<div class="section-text">{@html generalfaqcontent.content}</div>
							</div>
						</div>
					{/if}
				</div>
			{/each}
		</div>
	</TabPanel>
	<TabPanel>
		<div class="faq-section container">
			{#each registrationfaqs as registrationcontent}
				<div class="accordion">
					<div class="row no-gutters">
						<div class="col-lg-12 col-sm-12 col-xs-12">
							<div class="accordion-list" on:click={() => registrationfaqsopen(registrationcontent)}>
								<div class="question-title">{registrationcontent.title}</div>
								<div class="material-icons plus-icon">{registrationcontent.active ? 'remove_circle_outline' : 'add_circle_outline'}</div>
							</div>
						</div>
					</div>
					{#if registrationcontent.active}
						<div class="slider row no-gutters" transition:slide >
							<div class="col-12">
								<div class="section-text">{@html registrationcontent.content}</div>
							</div>
						</div>
					{/if}
				</div>
			{/each}
		</div>
	</TabPanel>
	<TabPanel>
		<div class="faq-section container">
			{#each tournamentfaqs as tournamentcontent}
				<div class="accordion">
					<div class="row no-gutters">
						<div class="col-lg-12 col-sm-12 col-xs-12">
							<div class="accordion-list" on:click={() => tournamentfaqsopen(tournamentcontent)}>
								<div class="question-title">{tournamentcontent.title}</div>
								<div class="material-icons plus-icon">{tournamentcontent.active ? 'remove_circle_outline' : 'add_circle_outline'}</div>
							</div>
						</div>
					</div>
					{#if tournamentcontent.active}
						<div class="slider row no-gutters" transition:slide  >
							<div class="col-12">
								<div class="section-text">{@html tournamentcontent.content}</div>
							</div>
						</div>
					{/if}
				</div>
			{/each}
		</div>
	</TabPanel>
	<!-- <TabPanel>
		<div class="faq-section container">
			{#each onlineQualifiersfaq as onlineQcontent}
				<div class="accordion">
					<div class="row no-gutters">
						<div class="col-lg-12 col-sm-12 col-xs-12">
							<div class="accordion-list" on:click={() => onlineQfaqsopen(onlineQcontent)}>
								<div class="question-title">{onlineQcontent.title}</div>
								<div class="material-icons plus-icon">{onlineQcontent.active ? 'remove_circle_outline' : 'add_circle_outline'}</div>
							</div>
						</div>
					</div>
					{#if onlineQcontent.active}
						<div class="slider row no-gutters" transition:slide >
							<div class="col-12">
								<div class="section-text">{@html onlineQcontent.content}</div>
							</div>
						</div>
					{/if}
				</div>
			{/each}
		</div>
	</TabPanel> -->
</Tabs>
<!-- <div class="container">
	<div class="row">
		<div class="col">
			<p>
				For additional support, please contact us at <a href="mailto:contactus@esports-battlegroundsmobileindia.com">contactus@esports-battlegroundsmobileindia.com</a>
			</p>
		</div>
	</div>
</div> -->
<style>
	.banner-section {
		margin: 0;
		min-height: 200px;
		/* background-color: #4675ea; */
		background: url("../images/banner.png") no-repeat center;
		background-size: cover;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.main-heading {
		color: #ffffff;
	}

	.faq-section {
		color: #0b2742;
		padding: 40px 10px;	
	}

	.accordion-list {
		cursor: pointer;
		padding: 20px 0;
		border-bottom: 1px solid #677790;
		display: flex;
		justify-content: space-between;
	}

	.accordion-list .material-icons {
		color: #677790;
		font-weight: bold;
	}

	.section-text {
		letter-spacing: 0;
		color: #261f14;
		font-size: 18px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.5;
		letter-spacing: normal;
		cursor: pointer;
	}

	.slider {
		padding-top: 40px;
	}
	
	.material-icons{
		color: #261f14;
		cursor: pointer;
	}

	.hindi-txt {
		margin-top: 20px;
	}

	.active {
		color: #000000;
	}
</style>